import { render } from "./PokerBoard.vue?vue&type=template&id=c2cbec5c"
import script from "./PokerBoard.vue?vue&type=script&lang=js"
export * from "./PokerBoard.vue?vue&type=script&lang=js"

import "./PokerBoard.vue?vue&type=style&index=0&id=c2cbec5c&lang=css"
script.render = render

export default script